import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormControl, FormField, FormItem, FormLabel } from '@/components/ui/form';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

const InputRadioGroup = ({
  name,
  className,
  options = '',
  isRequired = false,
  isDisabled = false,
  direction = 'column',
  label = '',
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { t } = useTranslation('translation', { keyPrefix: 'inputs' });

  const validationRules = {};

  if (isRequired) {
    validationRules.required = t('required');
  }

  return (
    <div className={` ${className}`}>
      <FormField
        name={name}
        key={name}
        control={control}
        defaultValue={false}
        rules={validationRules}
        render={({ field }) => (
          <FormItem className='tw-flex tw-flex-col tw-gap-0.5'>
            {label ? <FormLabel >{label}</FormLabel> : null}
            <FormControl>
              <RadioGroup
                disabled={isDisabled}
                value={field.value}
                onValueChange={(value) => {
                  if (value) {
                    field.onChange(value || null);
                  }
                }}
                className={`${
                  direction === 'row' ? '!tw-flex tw-flex-row tw-items-center tw-flex-wrap' : 'tw-space-y-1'
                } `}
              >
                {options.map((o, i) => (
                  <FormItem className='tw-flex tw-items-center tw-space-x-3 tw-space-y-0' key={i}>
                    <FormControl key={o.value} className='tw-mr-1'>
                      <RadioGroupItem value={o.value} />
                    </FormControl>
                    <FormLabel className='tw-font-normal'>{o.label}</FormLabel>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            {errors[name] && (
              <div className='d-flex align-items-center error-content'>
                <i className='fas fa-exclamation-triangle text-danger mr-2'></i>
                <p className='text-danger p-0 m-0'>{errors[name].message}</p>
              </div>
            )}
          </FormItem>
        )}
      />
    </div>
  );
};

export default InputRadioGroup;
